import { useTranslation } from 'react-i18next'
import { brandInfo } from '@/mocks/site'
import { storyGalleryItems } from '@/mocks/weddingStory'
import PageSeo from '@/components/feature/PageSeo'
import { SITE_URL, businessAreaServed } from '@/utils/schema'

export default function WeddingStorySeo() {
  const { t } = useTranslation()

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: t('weddingStory.title'),
    description: t('weddingStory.description'),
    image: storyGalleryItems.map((item) => item.image),
    articleSection: 'Real Wedding Story',
    inLanguage: t('weddingStory.seoLanguage'),
    author: {
      '@type': 'Organization',
      name: brandInfo.name,
      url: SITE_URL,
    },
    publisher: {
      '@type': 'Organization',
      name: brandInfo.name,
      logo: {
        '@type': 'ImageObject',
        url: brandInfo.logoImage,
      },
    },
    about: {
      '@type': 'Event',
      name: t('weddingStory.title'),
      eventType: 'Wedding',
      location: {
        '@type': 'Place',
        name: 'Madurai, Tamil Nadu',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Madurai',
          addressRegion: 'Tamil Nadu',
          addressCountry: 'IN',
        },
      },
    },
    areaServed: businessAreaServed,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${SITE_URL}/wedding-stories/aarthi-karthik`,
    },
  }

  return (
    <PageSeo
      title={t('seo.story.title')}
      description={t('seo.story.description')}
      path="/wedding-stories/aarthi-karthik"
      schemas={[articleSchema]}
    />
  )
}